import { SET_MAP_VIEW, CLEAR_MAP_VIEW } from 'actions/actionConstants'
import { createAppReducer } from 'lib/redux/reducerUtils'

export const initialMapViewState: App.MapViewState = {
  latitude: undefined,
  longitude: undefined,
  address: undefined,
}

const mapViewReducer = createAppReducer<App.MapViewState>(initialMapViewState, {
  [SET_MAP_VIEW]: (_state, action) => ({
    latitude: action.latitude,
    longitude: action.longitude,
    address: action.address,
  }),
  [CLEAR_MAP_VIEW]: () => initialMapViewState,
})

export default mapViewReducer
